<template>
  <section>
    <ul class="custom-list">
      <li v-for="item in options" :key="item.code">
        <span class="custom-item">{{ item.name }}</span>
      </li>
    </ul>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { buildStore } from '@/stores/build'
export default {
  name: 'installed-options',
  computed: {
    ...mapState(buildStore, ['build']),
    options() {
      return this.build.installed_options_details || []
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-item {
  width: 100%;
}
</style>
